import styled, { css } from 'styled-components'

import { Section as SectionGS } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { colors, fontSizes, media, radii, space } = theme

type LogoImageProps = {
  readonly $variant: 'cashme' | 'cyrela'
}

type SectionProps = {
  readonly $variant: 'default' | 'contrast'
  readonly $textSize: 'body1' | 'bodySmall'
}

export const Section = styled(SectionGS)<SectionProps>`
  padding-top: ${space['spacing-xxxl']};
  padding-bottom: ${space['spacing-xxxl']};

  h2 {
    margin-bottom: ${space['spacing-md']};
  }

  .ds-button {
    justify-content: center;
    padding: 0 ${space['spacing-giga']};
    margin-top: ${space['spacing-xl']};
    border-radius: ${radii['corner-radius-pill']};
  }

  @media (${media.tablet}) {
    padding-top: ${space['spacing-giga']};
    padding-bottom: ${space['spacing-giga']};

    & > div > div:nth-child(2) {
      order: 2;
    }

    & > div > div:last-child {
      order: 1;
    }
  }

  @media (${media.phone}) {
    .ds-button {
      width: 100%;
    }
  }

  ${({ $variant }) =>
    $variant === 'contrast' &&
    css`
      ${WrapperLogos} span {
        color: ${colors['neutral-text-contrast-default']};
      }
    `}

  ${({ $textSize }) =>
    $textSize === 'bodySmall' &&
    css`
      @media (${media.desktop}) {
        p {
          font-size: ${fontSizes['font-size-body-small']};
        }
      }
    `}
`

export const WrapperLogos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  height: 100%;

  span {
    color: ${colors['neutral-text-weak']};
  }
`

export const LogoImage = styled.div<LogoImageProps>`
  display: flex;

  @media (${media.phone}) {
    svg {
      max-width: ${({ $variant }) => ($variant === 'cashme' ? '65vw' : '50vw')};
    }
  }
`
